import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  Distributor: {
    id: 'label_distributor',
    defaultMessage: 'Distributor',
  },
  Items: {
    id: 'label_items',
    defaultMessage: 'Items',
  },
  ItemsHelp: {
    id: 'help_items',
    defaultMessage: 'Uses direct children of content if not set here.',
  },
});
